
import React from 'react';
import {Container} from 'react-bootstrap';

import Footer from './Footer';

 function Achievement(props) {
    
    return (
<>

<div className="achievementSection">
<h3 className='sectionHeading'>Achievements</h3>
<span className='headingAfterLine'></span>
<div className="achievementBoxWrap">
<div className="achievementBox">
    <div className="tittle">
    <h5>🏆 Major Events & Initiatives:</h5>
    </div>
    <div className="content">
    <ul>
    <li>
    Para Shot Put Training & Competition 2025: Organized in January 2025 at Chamundeshwari Playground, Jayanagara, with support from Puravankara.
    </li>
    <li>
    1st Karnataka Short Course Para Swimming Championship 2025: Conducted at Basavanagudi Aquatic Centre, Bengaluru, in collaboration with Puravankara CSR.
    </li>
<li>
    Wheelchair Cricket Workshops & Training Camps: Organized Karnataka’s first Wheelchair Cricket 2-day Workshop and Training in Camp (April 2024) at Siddaganga Institute of Technology, Tumkur, where 80 players participated.
    Formation of Karnataka’s 
    </li>
    <li>
    First Women’s Wheelchair Cricket Team: Successfully inaugurated the first women’s team in Karnataka, encouraging more female para-athletes to participate.
    </li>
    
    <li>
    Sumadhura Cup – Karnataka A vs Karnataka B Test Match: Successfully organized a Wheelchair Cricket Test Match between Karnataka A and Karnataka B teams.
    </li>
    <li>Women's Wheelchair Cricket T10 Matches: Conducted T10 matches for the newly formed Karnataka Women’s Wheelchair Cricket Team, marking a milestone in promoting women's para-cricket.
    </li>
    <li>1st Puravankara Para Badminton Training & Competition: Launched the first-ever Para Badminton Training and Competition in collaboration with Puravankara, encouraging para-athletes in a new sporting discipline.
    </li>
    <li>
    Para Sports Training Camps Across Karnataka: Organized multiple training camps for differently-abled athletes, providing skill development in various para-sports.
    </li>
    <li>Simply Periods Workshop for Para Women Athletes: Partnered with Simply Periods to conduct a workshop on menstrual health and hygiene for para-women athletes, addressing an essential aspect of their well-being.</li>
</ul>
    </div>
</div>
<div className="achievementBox">
    <div className="tittle">
    <h5>🏅 Athlete Achievements:</h5>
    </div>
    <div className="content">
    <ul>
    <li>12th Senior Men & Women Sitting Volleyball Championship 2024: Karnataka team secured a bronze medal, with both men’s and women’s teams achieving success.</li>
<li>
    6th Indian Open Para-Athletics International Championships 2024: Academy athletes won gold and bronze medals, showcasing excellence in para-athletics.
    </li>
    <li>
    12th Senior Men & Women Sitting Volleyball Championship 2024: Karnataka team won the bronze medal, with both men’s and women’s teams securing trophies.
    </li>
    <li>20 National Athletes & 5 International Athletes: The academy has produced 20 para-athletes who have represented Karnataka at the national level and 5 athletes competing at the international level.
    6th Indian Open Para-Athletics International Championships 2024: Academy athletes won gold and bronze medals, highlighting excellence in para-athletics.</li>
    <li>
    Parishrama Divyang Sports Academy – Achievements & Milestones
    Parishrama Divyang Sports Academy has made significant contributions to differently-abled sports, creating opportunities for para-athletes across Karnataka and beyond.
    </li>
        
</ul>
    </div>
</div>
</div>
</div>

</>

    )

}

export default Achievement
